import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';

@Component({
    selector: 'enterMedia',
    templateUrl: './enterMedia.component.html',
    styleUrls: ['./enterMedia.component.scss']
})
export class EnterMediaComponent implements AfterViewInit {

    @Input() otpError: boolean = false;
    @Input() otpCode: string;
    @Input() userEmail: string;
    @Input() otpErrorKey: string;
    @Output() otpCodeChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() userEmailChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() isEnterMediaFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('enterMediaForm') enterMediaForm: NgForm;

    ngAfterViewInit() {
        this.enterMediaForm.valueChanges.subscribe(_ => {
            this.isEnterMediaFormValid.emit(this.enterMediaForm.valid);
        });
    }
}
